import { Image, Text, View } from '@react-pdf/renderer';
import eyetelLogoImg from 'src/assets/img/eyetel-logo.png';
import clinicHeaderImg from 'src/assets/img/report-header-clinic.png';
import patientHeaderImg from 'src/assets/img/report-header-patient.png';

import useRemoteBoundStore from 'src/store/useRemoteBoundStore';

import { ReportType } from 'src/models/ReportType.model';

import { cls } from 'src/utils/reactPdfStyles';

interface IHeaderSectionProps {
  type: ReportType;
  title: string;
  logo: string;
}

const HeaderSection = ({ type, title, logo }: IHeaderSectionProps) => {
  const {
    practiceSettings: { shouldShowCompanyLogo, logoFile },
  } = useRemoteBoundStore.getState();

  switch (type) {
    case ReportType.CLINICAL: {
      return (
        <View>
          <View style={cls('report-header-container')}>
            <Image src={clinicHeaderImg} style={cls('header-img')} />
            {shouldShowCompanyLogo && logoFile && logo ? (
              <Image src={logo} style={cls('company-logo')} />
            ) : (
              <Image src={eyetelLogoImg} style={cls('company-logo')} />
            )}
          </View>

          <View style={cls('flex')}>
            <Text style={cls('h1 report-header-no-logo')}>{title}</Text>
          </View>
        </View>
      );
    }
    case ReportType.PATIENT: {
      return (
        <View>
          <View style={cls('report-header-container')}>
            <Image src={patientHeaderImg} style={cls('header-img')} />
            {shouldShowCompanyLogo && logoFile && logo ? (
              <Image src={logo} style={cls('company-logo')} />
            ) : (
              <Image src={eyetelLogoImg} style={cls('company-logo')} />
            )}
          </View>

          <View style={cls('flex')}>
            <Text style={cls('h1 report-header-no-logo')}> {title}</Text>
          </View>
        </View>
      );
    }

    default: {
      return (
        <Text style={cls('p')}>
          Unknown report type: {type}, title: {title}
        </Text>
      );
    }
  }
};

export default HeaderSection;
